var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardExpandBtn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 34,
    viewBox: "0 0 42 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H36C39.3137 0 42 2.68629 42 6V28C42 31.3137 39.3137 34 36 34H6C2.68629 34 0 31.3137 0 28V6Z",
    fill: "#619BF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 14.75L27.75 10.25M27.75 10.25L23.25 10.25M27.75 10.25L19.5 18.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.75H18.25C16.0409 11.75 14.25 13.5409 14.25 15.75V19.75C14.25 21.9591 16.0409 23.75 18.25 23.75H22.25C24.4591 23.75 26.25 21.9591 26.25 19.75V17",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardExpandBtn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card_expand_btn.f3cfc7ea4704a64eaa964dfd5fa9b102.svg";